<template>
    <div class="bg-white pb-3 p-2 shadow-sm rounded-lg">
        <form @submit.prevent="onSubmit" id="submit_form">
            <div class="container pt-3 pb-4 my-4 border in-border-header">
                <kt-form-section is_first>
                    <div class="section-header">
                        <span class="fa flaticon-settings"></span>
                        &nbsp;
                        {{ $t('label.direct_charge_port') }}
                    </div>
                    <div class="row m-2">

                        <div class="col-12 col-md-6 my-2">
                            <label for="selected_gateway" v-text="$t('label.set_dedicated_gateway')"></label>
                            <select class="form-control kt-selectpicker" id="selected_gateway"
                                    name="selected_gateway"
                                    v-model="form_data.selected_gateway">
                                <option :key="index" :value="gateway.id"
                                        v-for="(gateway, index) in active_collectives"
                                        v-text="gateway.name"
                                >
                                </option>
                            </select>
                        </div>
                    </div>
                </kt-form-section>
            </div>

            <!--            bank accounts start -->
            <div class="container pt-3 pb-4 my-4 border in-border-header">
                <kt-form-section is_first>
                    <div class="section-header">
                        <span class="fa flaticon-settings"></span>
                        &nbsp;
                        {{ $t('label.default_withdrawal_bank_accounts') }}
                    </div>
                    <div class="row m-2">
                        <div class="col-12 col-md-6 my-2">
                            <label for="saderat_bank_account" v-text="$t('label.saderat_bank_account')"></label>
                            <select class="form-control kt-selectpicker" id="saderat_bank_account"
                                    name="saderat_bank_account"
                                    v-model="form_data.saderat_bank_account">
                                <option :key="index" :value="account.number"
                                        v-for="(account, index) in form_data.all_saderat_bank_accounts"
                                        v-text="account.number + ' (' + account.fa_name + ')'"
                                >
                                </option>
                            </select>
                        </div>

                        <div class="col-12 col-md-6 my-2">
                            <label for="keshavarzi_bank_account" v-text="$t('label.keshavarzi_bank_account')"></label>
                            <select class="form-control kt-selectpicker" id="keshavarzi_bank_account"
                                    name="keshavarzi_bank_account"
                                    v-model="form_data.keshavarzi_bank_account">
                                <option :key="index" :value="account.number"
                                        v-for="(account, index) in form_data.all_keshavarzi_bank_accounts"
                                        v-text="account.number + ' (' + account.fa_name + ')'"
                                >
                                </option>
                            </select>
                        </div>
                        <div class="col-12 col-md-6 my-2">
                            <label for="saman_bank_account" v-text="$t('label.saman_bank_account')"></label>
                            <select class="form-control kt-selectpicker" id="saman_bank_account"
                                    name="saman_bank_account"
                                    v-model="form_data.saman_bank_account">
                                <option :key="index" :value="account.number"
                                        v-for="(account, index) in form_data.all_saman_bank_accounts"
                                        v-text="account.number + ' (' + account.fa_name + ')'"
                                >
                                </option>
                            </select>
                        </div>
                        <div class="col-12 col-md-6 my-2">
                            <label for="sanbod_pasargad_bank_account"
                                   v-text="$t('label.sanbod_pasargad_bank_account')"></label>
                            <select class="form-control kt-selectpicker" id="sanbod_pasargad_bank_account"
                                    name="sanbod_pasargad_bank_account"
                                    v-model="form_data.sanbod_pasargad_bank_account">
                                <option :key="index" :value="account.number"
                                        v-for="(account, index) in form_data.all_sanbod_pasargad_bank_accounts"
                                        v-text="account.number + ' (' + account.fa_name + ')'"
                                >
                                </option>
                            </select>
                        </div>
                        <div class="col-12 col-md-6 my-2">
                            <label for="sanbod_parsian_bank_account"
                                   v-text="$t('label.sanbod_parsian_bank_account')"></label>
                            <select class="form-control kt-selectpicker" id="sanbod_parsian_bank_account"
                                    name="sanbod_parsian_bank_account"
                                    v-model="form_data.sanbod_parsian_bank_account">
                                <option :key="index" :value="account.number"
                                        v-for="(account, index) in form_data.all_sanbod_parsian_bank_accounts"
                                        v-text="account.number + ' (' + account.fa_name + ')'"
                                >
                                </option>
                            </select>
                        </div>
                        <div class="col-12 col-md-6 my-2">
                            <label for="sanbod_sina_bank_account" v-text="$t('label.sanbod_sina_bank_account')"></label>
                            <select class="form-control kt-selectpicker" id="sanbod_sina_bank_account"
                                    name="sanbod_sina_bank_account"
                                    v-model="form_data.sanbod_sina_bank_account">
                                <option :key="index" :value="account.number"
                                        v-for="(account, index) in form_data.all_sanbod_sina_bank_accounts"
                                        v-text="account.number + ' (' + account.fa_name + ')'"
                                >
                                </option>
                            </select>
                        </div>
                        <div class="col-12 col-md-6 my-2">
                            <label for="sanbod_tejarat_bank_account"
                                   v-text="$t('label.sanbod_tejarat_bank_account')"></label>
                            <select class="form-control kt-selectpicker" id="sanbod_tejarat_bank_account"
                                    name="sanbod_tejarat_bank_account"
                                    v-model="form_data.sanbod_tejarat_bank_account">
                                <option :key="index" :value="account.number"
                                        v-for="(account, index) in form_data.all_sanbod_tejarat_bank_accounts"
                                        v-text="account.number + ' (' + account.fa_name + ')'"
                                >
                                </option>
                            </select>
                        </div>
                        <div class="col-12 col-md-6 my-2">
                            <label for="ayande_bank_account" v-text="$t('label.ayande_bank_account')"></label>
                            <select class="form-control kt-selectpicker" id="ayande_bank_account"
                                    name="ayande_bank_account"
                                    v-model="form_data.ayande_bank_account">
                                <option :key="index" :value="account.number"
                                        v-for="(account, index) in form_data.all_ayande_bank_accounts"
                                        v-text="account.number + ' (' + account.fa_name + ')'"
                                >
                                </option>
                            </select>
                        </div>

                        <div class="col-12 col-md-6 my-2">
                            <label for="faraboom_melli_bank_account"
                                   v-text="$t('label.faraboom_melli_bank_account')"></label>
                            <select class="form-control kt-selectpicker" id="faraboom_melli_bank_account"
                                    name="faraboom_melli_bank_account"
                                    v-model="form_data.faraboom_melli_bank_account">
                                <option :key="index" :value="account.number"
                                        v-for="(account, index) in form_data.all_faraboom_melli_bank_accounts"
                                        v-text="account.number + ' (' + account.fa_name + ')'"
                                >
                                </option>
                            </select>
                        </div>

                        <div class="col-12 col-md-6 my-2">
                            <label for="mellat_bank_account"
                                   v-text="$t('label.mellat_bank_account')"></label>
                            <select class="form-control kt-selectpicker" id="mellat_bank_account"
                                    name="mellat_bank_account"
                                    v-model="form_data.mellat_bank_account">
                                <option :key="index" :value="account.number"
                                        v-for="(account, index) in form_data.all_mellat_bank_accounts"
                                        v-text="account.number + ' (' + account.fa_name + ')'"
                                >
                                </option>
                            </select>
                        </div>

                        <div class="col-12 col-md-6 my-2">
                            <label for="settlement_provider_variant"
                                   v-text="$t('wallets.label.settlement_provider_variant')"></label>
                            <select class="form-control"
                                    id="settlement_provider_variant"
                                    name="settlement_provider_variant"
                                    v-model="settlement_provider_variant"
                            >
                                <option v-for="(value, name, index) in SettlementProviderVariant" :key="index"
                                        v-text="SettlementProviderVariantStr.get(value)"
                                        :value="value"
                                >
                                </option>
                            </select>
                        </div>
                    </div>
                </kt-form-section>
            </div>
            <!--            bank accounts end-->

            <!--            webservice wage start-->
            <div class="container pt-3 pb-4 my-4 border in-border-header">
                <kt-form-section is_first>
                    <div class="section-header">
                        <span class="fa flaticon-settings"></span>
                        &nbsp;
                        {{ $t('label.service_provider_wage') }}
                    </div>
                    <div class="row m-2">
                        <div class="col-12 col-md-6 my-2">
                            <label for="wage_type" v-text="$t('label.wage_type')"></label>
                            <select class="form-control" id="wage_type" name="wage_type" v-model="form_data.wage_type">
                                <!-- NOTE: we didnt use v-for cuz we shouldn't include SAME_AS_GLOBAL here -->
                                <option v-text="walletWageTypeStr.get(walletWageType.CONSTANT)"
                                        :value="walletWageType.CONSTANT"
                                >
                                </option>
                                <option v-text="walletWageTypeStr.get(walletWageType.PERCENT)"
                                        :value="walletWageType.PERCENT"
                                >
                                </option>
                                <option v-text="walletWageTypeStr.get(walletWageType.LIMITED_PERCENT)"
                                        :value="walletWageType.LIMITED_PERCENT"
                                >
                                </option>
                            </select>
                        </div>
                        <div v-if="form_data.wage_type === walletWageType.LIMITED_PERCENT
                                || form_data.wage_type === walletWageType.PERCENT"
                             class="col-12 col-md-6 my-2">
                            <label for="wage_percent" v-text="$t('label.wage_percent')"></label>
                            <input class="form-control"
                                   dir="ltr"
                                   id="wage_percent"
                                   name="wage_percent"
                                   v-model="form_data.wage_percent"
                            >
                        </div>

                        <div v-if="form_data.wage_type === walletWageType.CONSTANT
                                || form_data.wage_type === walletWageType.LIMITED_PERCENT"
                             class="col-12 col-md-6 my-2">
                            <label for="wage_amount"
                                   v-text="form_data.wage_type === walletWageType.LIMITED_PERCENT ?
                                        $t('label.max_wage') : $t('label.wage_amount')"
                            >
                            </label>
                            <input class="form-control"
                                   dir="ltr"
                                   id="wage_amount"
                                   name="wage_amount"
                                   v-model="form_data.wage_amount"
                            >
                        </div>

                        <div v-if="form_data.wage_type === walletWageType.LIMITED_PERCENT"
                             class="col-12 col-md-6 my-2">
                            <label for="min_wage_amount" v-text="$t('label.min_wage_amount')"></label>
                            <input class="form-control"
                                   dir="ltr"
                                   id="min_wage_amount"
                                   name="min_wage_amount"
                                   v-model="form_data.min_wage_amount"
                            >
                        </div>
                    </div>
                </kt-form-section>
            </div>
            <!--             webservice wage end-->

            <!--            paystar wage start-->
            <div class="container pt-3 pb-4 my-4 border in-border-header">
                <kt-form-section is_first>
                    <div class="section-header">
                        <span class="fa flaticon-settings"></span>
                        &nbsp;
                        {{ fetch_starshop ?  $t('label.starshop_wage') : $t('label.paystar_wage') }}
                    </div>
                    <div class="row m-2">
                        <div class="col-12 col-md-6 my-2">
                            <label for="paystar_wage_type" v-text="$t('label.wage_type')"></label>
                            <select class="form-control" id="paystar_wage_type" name="paystar_wage_type"
                                    v-model="form_data.paystar_wage_type">
                                <!-- NOTE: we didnt use v-for cuz we shouldn't include SAME_AS_GLOBAL here -->
                                <option v-text="walletWageTypeStr.get(walletWageType.CONSTANT)"
                                        :value="walletWageType.CONSTANT"
                                >
                                </option>
                                <option v-text="walletWageTypeStr.get(walletWageType.PERCENT)"
                                        :value="walletWageType.PERCENT"
                                >
                                </option>
                                <option v-text="walletWageTypeStr.get(walletWageType.LIMITED_PERCENT)"
                                        :value="walletWageType.LIMITED_PERCENT"
                                >
                                </option>
                            </select>
                        </div>

                        <div v-if="form_data.paystar_wage_type === walletWageType.LIMITED_PERCENT
                                || form_data.paystar_wage_type === walletWageType.PERCENT"
                             class="col-12 col-md-6 my-2">
                            <label for="paystar_wage_percent" v-text="$t('label.wage_percent')"></label>
                            <input class="form-control"
                                   dir="ltr"
                                   id="paystar_wage_percent"
                                   name="paystar_wage_percent"
                                   v-model="form_data.paystar_wage_percent"
                            >
                        </div>

                        <div v-if="form_data.paystar_wage_type === walletWageType.CONSTANT
                                || form_data.paystar_wage_type === walletWageType.LIMITED_PERCENT"
                             class="col-12 col-md-6 my-2">
                            <label for="paystar_wage_amount"
                                   v-text="form_data.paystar_wage_type === walletWageType.LIMITED_PERCENT ?
                                        $t('label.max_wage') : $t('label.wage_amount')"
                            >
                            </label>
                            <input class="form-control"
                                   dir="ltr"
                                   id="paystar_wage_amount"
                                   name="paystar_wage_amount"
                                   v-model="form_data.paystar_wage_amount"
                            >
                        </div>

                        <div v-if="form_data.paystar_wage_type === walletWageType.LIMITED_PERCENT"
                             class="col-12 col-md-6 my-2">
                            <label for="paystar_min_wage_amount" v-text="$t('label.min_wage_amount')"></label>
                            <input class="form-control"
                                   dir="ltr"
                                   id="paystar_min_wage_amount"
                                   name="paystar_min_wage_amount"
                                   v-model="form_data.paystar_min_wage_amount"
                            >
                        </div>
                    </div>
                </kt-form-section>
            </div>
            <!--            paystar wage end-->
            <!--            refund wage start-->
            <div class="container pt-3 pb-4 my-4 border in-border-header">
                <kt-form-section is_first>
                    <div class="section-header">
                        <span class="fa flaticon-settings"></span>
                        &nbsp;
                        {{ $t('label.refund_wage') }}
                    </div>
                    <div class="row m-2">
                        <div class="col-12 col-md-6 my-2">
                            <label for="paystar_wage_type" v-text="$t('label.wage_type')"></label>
                            <select class="form-control" id="paystar_wage_type" name="paystar_wage_type"
                                    v-model="form_data.refund_wage_type">
                                <!-- NOTE: we didnt use v-for cuz we shouldn't include SAME_AS_GLOBAL here -->
                                <option v-text="walletWageTypeStr.get(walletWageType.CONSTANT)"
                                        :value="walletWageType.CONSTANT"
                                >
                                </option>
                                <option v-text="walletWageTypeStr.get(walletWageType.PERCENT)"
                                        :value="walletWageType.PERCENT"
                                >
                                </option>
                                <option v-text="walletWageTypeStr.get(walletWageType.LIMITED_PERCENT)"
                                        :value="walletWageType.LIMITED_PERCENT"
                                >
                                </option>
                            </select>
                        </div>

                        <div v-if="form_data.refund_wage_type === walletWageType.LIMITED_PERCENT
                                || form_data.refund_wage_type === walletWageType.PERCENT"
                             class="col-12 col-md-6 my-2">
                            <label for="paystar_wage_percent" v-text="$t('label.wage_percent')"></label>
                            <input class="form-control"
                                   dir="ltr"
                                   id="paystar_wage_percent"
                                   name="paystar_wage_percent"
                                   v-model="form_data.refund_wage_percent"
                            >
                        </div>

                        <div v-if="form_data.refund_wage_type === walletWageType.CONSTANT
                                || form_data.refund_wage_type === walletWageType.LIMITED_PERCENT"
                             class="col-12 col-md-6 my-2">
                            <label for="paystar_wage_amount"
                                   v-text="form_data.refund_wage_type === walletWageType.LIMITED_PERCENT ?
                                        $t('label.max_wage') : $t('label.wage_amount')"
                            >
                            </label>
                            <input class="form-control"
                                   dir="ltr"
                                   id="paystar_wage_amount"
                                   name="paystar_wage_amount"
                                   v-model="form_data.refund_wage_amount"
                            >
                        </div>

                        <div v-if="form_data.refund_wage_type === walletWageType.LIMITED_PERCENT"
                             class="col-12 col-md-6 my-2">
                            <label for="paystar_min_wage_amount" v-text="$t('label.min_wage_amount')"></label>
                            <input class="form-control"
                                   dir="ltr"
                                   id="paystar_min_wage_amount"
                                   name="paystar_min_wage_amount"
                                   v-model="form_data.refund_min_wage_amount"
                            >
                        </div>
                    </div>
                </kt-form-section>
            </div>
            <!--            refund wage end-->

            <!--            paystar wage account start-->
            <div class="container pt-3 pb-4 my-4 border in-border-header">
                <kt-form-section is_first>
                    <div class="section-header">
                        <span class="fa flaticon-settings"></span>
                        &nbsp;
                        {{ fetch_starshop ?  $t('label.starshop_company_wage_account') : $t('label.company_wage_account') }}
                    </div>
                    <div class="row m-2">
                        <div class="col-12 col-md-6 my-2">
                            <label for="company_wage_account" v-text="$t('label.destination_account')"></label>
                            <select class="form-control kt-selectpicker"
                                    name="company_wage_account"
                                    id="company_wage_account"
                                    v-model="form_data.company_wage_account">
                                <option :key="index" :value="account.iban"
                                        v-for="(account, index) in form_data.all_company_wage_accounts"
                                        v-text="account.iban + ' (' + account.name + ')'"
                                >
                                </option>
                            </select>
                        </div>
                        <div class="col-12 col-md-6 my-2">
                            <label for="company_wage_account_origin_bank" v-text="$t('label.origin_bank')"></label>
                            <select class="form-control kt-selectpicker"
                                    name="company_wage_account"
                                    id="company_wage_account_origin_bank"
                                    v-model="form_data.company_wage_account_origin_bank">
                                <option :value="bankId.saderat" v-text="bankIdStr.get(bankId.saderat)"></option>
                                <option :value="bankId.keshavarzi" v-text="bankIdStr.get(bankId.keshavarzi)"></option>
                                <option :value="bankId.ayande" v-text="bankIdStr.get(bankId.ayande)"></option>
                            </select>
                        </div>
                    </div>
                </kt-form-section>
            </div>
            <!--            paystar wage account end-->

            <!--            paystar settlement wage start-->
            <div class="container pt-3 pb-4 my-4 border in-border-header">
                <kt-form-section is_first>
                    <div class="section-header">
                        <span class="fa flaticon-settings"></span>
                        &nbsp;
                        {{ fetch_starshop ? $t('label.starshop_wage_charge') : $t('label.paystar_wage_charge') }}
                    </div>
                    <div class="row m-2">
                        <div class="col-12 col-md-6 my-2">
                            <label for="paystar_wage_charge_type" v-text="$t('label.wage_type')"></label>
                            <select class="form-control" id="paystar_wage_charge_type" name="paystar_wage_charge_type"
                                    v-model="form_data.paystar_wage_charge_type">
                                <!-- NOTE: we didnt use v-for cuz we shouldn't include SAME_AS_GLOBAL here -->
                                <option v-text="walletWageTypeStr.get(walletWageType.CONSTANT)"
                                        :value="walletWageType.CONSTANT"
                                >
                                </option>
                                <option v-text="walletWageTypeStr.get(walletWageType.PERCENT)"
                                        :value="walletWageType.PERCENT"
                                >
                                </option>
                                <option v-text="walletWageTypeStr.get(walletWageType.LIMITED_PERCENT)"
                                        :value="walletWageType.LIMITED_PERCENT"
                                >
                                </option>
                            </select>
                        </div>

                        <div v-if="form_data.paystar_wage_charge_type === walletWageType.LIMITED_PERCENT
                                || form_data.paystar_wage_charge_type === walletWageType.PERCENT"
                             class="col-12 col-md-6 my-2">
                            <label for="paystar_wage_charge_percent" v-text="$t('label.wage_percent')"></label>
                            <input class="form-control"
                                   dir="ltr"
                                   id="paystar_wage_charge_percent"
                                   name="paystar_wage_charge_percent"
                                   v-model="form_data.paystar_wage_charge_percent"
                            >
                        </div>

                        <div v-if="form_data.paystar_wage_charge_type === walletWageType.CONSTANT
                                || form_data.paystar_wage_charge_type === walletWageType.LIMITED_PERCENT"
                             class="col-12 col-md-6 my-2">
                            <label for="paystar_wage_charge_amount"
                                   v-text="form_data.paystar_wage_charge_type === walletWageType.LIMITED_PERCENT ?
                                        $t('label.max_wage') : $t('label.wage_amount')"
                            >
                            </label>
                            <input class="form-control"
                                   dir="ltr"
                                   id="paystar_wage_charge_amount"
                                   name="paystar_wage_charge_amount"
                                   v-model="form_data.paystar_wage_charge_amount"
                            >
                        </div>

                        <div v-if="form_data.paystar_wage_charge_type === walletWageType.LIMITED_PERCENT"
                             class="col-12 col-md-6 my-2">
                            <label for="paystar_min_wage_charge_amount" v-text="$t('label.min_wage_amount')"></label>
                            <input class="form-control"
                                   dir="ltr"
                                   id="paystar_min_wage_charge_amount"
                                   name="paystar_min_wage_charge_amount"
                                   v-model="form_data.paystar_min_wage_charge_amount"
                            >
                        </div>
                    </div>
                </kt-form-section>
            </div>
            <!--            paystar settlement wage start-->

            <!--            bank account for shared settlement setting start-->
            <div class="container pt-3 pb-4 my-4 border in-border-header" v-if="!fetch_starshop">
                <kt-form-section is_first>
                    <div class="section-header ">
                        <span class="fa flaticon-settings"></span>
                        &nbsp;
                        {{ $t('label.default_bank_account_for_shared_settlement') }}
                    </div>
                    <div class="row m-2">
                        <div v-for="(item, value, index) in form_data.all_settlement_bank_accounts" :key="index"
                             class="col-12 col-md-6 my-2">
                            <label :for="value" v-text="$t('label.bank') + ' ' + bankIdStr.get(value)"></label>
                            <select class="form-control kt-selectpicker" :id="value"
                                    :name="bankId.get(value) + '_settlement_bank_account'"
                                    v-model="form_data[bankId.get(value) + '_settlement_bank_account']">
                                <option :key="index" :value="account.iban"
                                        v-for="(account, index) in item"
                                        v-text="account.iban + ' (' + account.name + ')'"
                                >
                                </option>
                            </select>
                        </div>

                    </div>
                </kt-form-section>
            </div>
            <!--            DELETED ON STARSHOP !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!-->
            <!--            bank account for shared settlement setting end-->

            <!--            iban info setting start-->
            <div class="container pt-3 pb-4 my-4 border in-border-header">
                <kt-form-section is_first>
                    <div class="section-header ">
                        <span class="fa flaticon-settings"></span>
                        &nbsp;
                        {{ $t('label.iban_detect_settings') }}
                    </div>
                    <div class="row m-2">
                        <div class="col-12 col-md-6 my-2">
                            <label for="iban_detect_wage" v-text="$t('label.iban_detect_wage')"></label>
                            <input class="form-control"
                                   dir="ltr"
                                   id="iban_detect_wage"
                                   name="iban_detect_wage"
                                   v-model="form_data.iban_detect_wage"
                            >
                        </div>

                        <div class="col-12 col-md-6 my-2">
                            <label for="iban_detect_status" v-text="$t('label.iban_detect_status')"></label>
                            <select class="form-control" id="iban_detect_status" name="iban_detect_status"
                                    v-model="form_data.iban_detect_status">
                                <option :value="ibanDetectStatus.ACTIVE"
                                        v-text="ibanDetectStatusStr.get(ibanDetectStatus.ACTIVE)"
                                ></option>
                                <option :value="ibanDetectStatus.INACTIVE"
                                        v-text="ibanDetectStatusStr.get(ibanDetectStatus.INACTIVE)"
                                ></option>
                            </select>
                        </div>

                        <div class="col-12 col-md-6 my-2">
                            <label for="is_transfer_valid" v-text="$t('label.is_transfer_valid')"></label>
                            <select class="form-control" id="is_transfer_valid" name="is_transfer_valid"
                                    v-model="form_data.is_transfer_valid">
                                <option :value="validTransferSettingStatus.ACTIVE"
                                        v-text="validTransferSettingStatusStr.get(validTransferSettingStatus.ACTIVE)"
                                ></option>
                                <option :value="validTransferSettingStatus.INACTIVE"
                                        v-text="validTransferSettingStatusStr.get(validTransferSettingStatus.INACTIVE)"
                                ></option>
                            </select>
                        </div>

                        <div class="col-12 col-md-6 my-2">
                            <label for="first_priority_for_iban_info" v-text="$t('wallets.label.first_priority_iban_info')"></label>
                            <select class="form-control" id="first_priority_for_iban_info" name="first_priority_for_iban_info"
                                    v-model="form_data.first_priority_for_iban_info">
                                <option v-for="(item, index) in form_data.valid_providers_for_get_iban_info" :value="item" :key="index"
                                        v-text="$t(`wallets.providers.${item}`)"
                                ></option>
                            </select>
                        </div>

                        <div class="col-12 col-md-6 my-2">
                            <label for="last_priority_for_iban_info" v-text="$t('wallets.label.last_priority_iban_info')"></label>
                            <select class="form-control" id="first_priority_for_iban_info" name="last_priority_for_iban_info"
                                    v-model="form_data.last_priority_for_iban_info">
                                <option v-for="(item, index) in form_data.valid_providers_for_get_iban_info" :value="item" :key="index"
                                        v-text="$t(`wallets.providers.${item}`)"
                                ></option>
                            </select>
                        </div>
                    </div>
                </kt-form-section>
            </div>
            <!--            iban info setting end-->

            <!--            general wallet setting start-->
            <div class="container pt-3 pb-4 my-4 border in-border-header">
                <kt-form-section is_first>
                    <div v-if="$can('read-general-info', 'user')">
                        <div class="section-header ">
                            <span class="fa flaticon-settings"></span>
                            &nbsp;
                            {{ $t('label.wallet_general_settings') }}
                        </div>
                        <div class="p-4 rounded shadow-sm">
                            <div class="row align-items-baseline">
                                <div class="col-12 col-md-6 my-2">
                                    <label for="skip_days"
                                            v-text="$t('label.coming_holidays')"
                                    >
                                    </label>
                                    <input type="text"
                                            class="form-control"
                                            id="skip_days"
                                            name="skip_days"
                                            v-model="form_data.skip_days"
                                    >
                                </div>

                                <div class="col-12 col-md-6 my-2">
                                    <label for="settlement_request_period_limit"
                                            v-text="$t('label.wallet_settlement_request_period_limit')"
                                    >
                                    </label>
                                    <input type="text"
                                            class="form-control"
                                            id="settlement_request_period_limit"
                                            name="settlement_request_period_limit"
                                            v-model="form_data.settlement_request_period_limit"
                                    >
                                </div>
                                <div class="col-12 col-md-6 my-2">
                                    <label for="is_active" v-text="$t('label.wallet_status')"></label>
                                    <select class="form-control" id="is_active" name="is_active"
                                            v-model="form_data.is_active">
                                        <option :value="true"
                                                v-text="$t('label.active')"
                                        ></option>
                                        <option :value="false"
                                                v-text="$t('label.inactive')"
                                        ></option>
                                    </select>
                                </div>
                                <div class="col-12 col-md-6 my-2">
                                    <label for="settlement_limit" v-text="$t('label.settlement_limit')"></label>
                                    <input class="form-control"
                                           dir="ltr"
                                           id="settlement_limit"
                                           name="settlement_limit"
                                           v-model="form_data.settlement_limit"
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </kt-form-section>
            </div>

            <!--            general wallet setting end-->

            <!--            upcoming settlement setting start-->
            <div class="container pt-3 pb-4 my-4 border in-border-header">
                <kt-form-section is_first>
                    <div class="section-header">
                        <span class="fa flaticon-settings"></span>
                        &nbsp;
                        {{ $t('label.upcoming_settlement_wage') }}
                    </div>
                    <div class="row m-2">
                        <div class="col-12 col-md-6 my-2">
                            <label for="upcoming_settlement_wage_percent" v-text="$t('label.wage_percent')"></label>
                            <input class="form-control"
                                   dir="ltr"
                                   id="upcoming_settlement_wage_percent"
                                   name="upcoming_settlement_wage_percent"
                                   v-model="form_data.upcoming_settlement_wage_percent"
                            >
                        </div>

                        <div class="col-12 col-md-6 my-2">
                            <label for="upcoming_settlement_wage_max"
                                   v-text="$t('label.max_wage')"
                            >
                            </label>
                            <input class="form-control"
                                   dir="ltr"
                                   id="upcoming_settlement_wage_max"
                                   name="upcoming_settlement_wage_max"
                                   v-model="form_data.upcoming_settlement_wage_max"
                            >
                        </div>

                        <div class="col-12 col-md-6 my-2">
                            <label for="upcoming_settlement_wage_min" v-text="$t('label.min_wage_amount')"></label>
                            <input class="form-control"
                                   dir="ltr"
                                   id="upcoming_settlement_wage_min"
                                   name="upcoming_settlement_wage_min"
                                   v-model="form_data.upcoming_settlement_wage_min"
                            >
                        </div>
                    </div>
                </kt-form-section>
            </div>
            <!--            upcoming settlement setting end-->

            <!--            transaction pending setting start-->
            <div class="container pt-3 pb-4 my-4 border in-border-header">
                <kt-form-section is_first>
                    <div class="section-header">
                        <span class="fa flaticon-settings"></span>
                        &nbsp;
                        {{ $t('label.releasing_charge_pending_transactions_settings') }}
                    </div>
                    <div class="row m-2">
                        <div class="col-12 col-md-6 my-2">
                            <label for="releasing_type" v-text="$t('label.releasing_type')"></label>
                            <select class="form-control" id="releasing_type" name="releasing_type"
                                    v-model="form_data.releasing_type">
                                <option :value="releasingType.ALL"
                                        v-text="releasingTypeStr.get(releasingType.ALL)"
                                ></option>
                                <option :value="releasingType.BASED_ON_BALANCE"
                                        v-text="releasingTypeStr.get(releasingType.BASED_ON_BALANCE)"
                                ></option>
                            </select>
                        </div>
                        <div v-if="form_data.releasing_type == releasingType.BASED_ON_BALANCE"
                             class="col-12 col-md-6 my-2">
                            <label for="account_balance" v-text="$t('label.account_balance')"></label>
                            <input class="form-control"
                                   dir="ltr"
                                   id="account_balance"
                                   name="account_balance"
                                   v-model="form_data.account_balance"
                            >
                        </div>
                    </div>
                </kt-form-section>
            </div>
            <!--            transaction pending setting end-->

            <div class="col-12 mt-4">
                <button class="btn btn-success mx-3" type="submit" :disabled="!wallet_data_fetched_successfully" v-text="form_meta_data.submit_btn_text"></button>
                <button v-if="$can('run-auto-settlement-creation','tech-support')"
                    class="btn btn-primary mx-3"
                        type="button"
                        v-text="$t('wallets.btn.create_wallet_auto_settlement_requests')"
                        :disabled="createAutoSettlementRequestBtnDisable"
                        @click="createAutoSettlementRequest()"
                ></button>
                <button v-if="$can('run-wallet-manual-charge','tech-support')"
                        class="btn btn-dark mx-3"
                        id="charge_manually"
                        type="button"
                        v-text="$t('wallets.btn.charge_wallets_manually')"
                        @click="chargeWalletManually()"
                ></button>
            </div>
        </form>
    </div>
</template>

<script>
import {i18n} from "@/plugins/i18n";
import $ from "jquery";
import {walletService} from "@/common/api.service";
import {walletWageType, walletWageTypeStr} from "@/constants/WalletWageType";
import {releasingType, releasingTypeStr} from "@/constants/releasingType";
import {ibanDetectStatus, ibanDetectStatusStr} from "@/constants/ibanDetectStatus";
import {SettlementProviderVariant, SettlementProviderVariantStr} from "@/constants/SettlementProviderVariant";
import {bankId, bankIdStr} from "@/constants/bankId";
import {validTransferSettingStatus, validTransferSettingStatusStr} from "@/constants/validTransferSettingStatus";
import {KTApp} from "@/plugins/core/app";

export default {
    props: {
        fetch_starshop: {
            default: false,
            type: Boolean
        }
    },
    computed: {
        validTransferSettingStatusStr() {
            return validTransferSettingStatusStr
        },
        validTransferSettingStatus() {
            return validTransferSettingStatus
        },
        bankId() {
            return bankId
        },
        bankIdStr() {
            return bankIdStr
        }
    },
    data() {
        return {
            ibanDetectStatus,
            ibanDetectStatusStr,
            SettlementProviderVariant,
            SettlementProviderVariantStr,
            createAutoSettlementRequestBtnDisable: false,
            active_collectives: [],
            walletWageType,
            walletWageTypeStr,
            releasingType,
            releasingTypeStr,
            form_data: {
                selected_gateway: null,
                wage_type: walletWageType.CONSTANT,
                wage_percent: 0,
                wage_amount: 0,
                min_wage_amount: 0,
                paystar_wage_type: walletWageType.CONSTANT,
                paystar_wage_percent: 0,
                paystar_wage_amount: 0,
                paystar_min_wage_amount: 0,
                refund_wage_type: walletWageType.CONSTANT,
                refund_wage_percent: 0,
                refund_wage_amount: 0,
                refund_min_wage_amount: 0,
                releasing_type: 1,
                account_balance: 0,
                iban_detect_status: validTransferSettingStatus.ACTIVE,
                is_transfer_valid: ibanDetectStatus.ACTIVE,
                iban_detect_wage: 0,
                paystar_wage_charge_type: walletWageType.CONSTANT,
                paystar_wage_charge_amount: 0,
                paystar_wage_charge_percent: 0,
                min_wage_charge_amount: 0,
                saderat_settlement_bank_account: '',
                saman_settlement_bank_account: '',
                ayande_settlement_bank_account: '',
                keshavarzi_settlement_bank_account: '',
                skip_days: 0,
                settlement_request_period_limit: 0,
                is_active: true,
                upcoming_settlement_wage_percent: 0.05,
                upcoming_settlement_wage_max: 50000,
                upcoming_settlement_wage_min: 5000,
                first_priority_for_iban_info: '',
                last_priority_for_iban_info: '',
                settlement_limit: 10000000,
            },
            settlement_provider_variant: SettlementProviderVariant.BASED_ON_SETTLEMENT_BANK,
            form_meta_data: {
                submit_btn_progress: false,
                submit_btn_text: i18n.t('btn.submit_changes'),
            },
            wallet_data_fetched_successfully: false,
        };
    },
    methods: {
        createAutoSettlementRequest() {
            this.createAutoSettlementRequestBtnDisable = true;
            let form = $('#submit_form');

            const createAutoSettlement = this.fetch_starshop
                ? walletService.adminCreateStarShopAutoSettlementRequest
                : walletService.adminCreateAutoSettlementRequest;

            createAutoSettlement().then(res => {
                this.$router.push('/wallets');
            }).catch(({response}) => {
                this.showMsg(form, 'danger', response.data.message);

                if (response.data && response.data.data) {
                    form.validate().showErrors(response.data.data);
                }
            }).finally(() => {
                this.createAutoSettlementRequestBtnDisable = false;
            });
        },
        chargeWalletManually() {
            let btn = $('#charge_manually');

            KTApp.progress(btn)
            const chargeWallet = this.fetch_starshop
                ? walletService.chargeStarShopWalletManually
                : walletService.chargeWalletManually;

            chargeWallet().then(({data}) => {
                this.toastr.success(data.message);
            }).catch(({response}) => {
                this.toastr.error(response.data.message);

            }).finally(() => {
                KTApp.unprogress(btn)
            });
        },
        onSubmit() {
            let form = $('#submit_form');

            form.validate({
                rules: {
                    selected_gateway: {
                        required: false,
                    },
                    iban_detect_status: {
                        required: false,
                    },
                    is_transfer_valid: {
                        required: false,
                    },
                    last_priority_for_iban_info: {
                        required: false,
                    },
                    first_priority_for_iban_info: {
                        required: false,
                    },
                    iban_detect_wage: {
                        required: false,
                    },
                    saderat_bank_account: {
                        required: false,
                    },
                    keshavarzi_bank_account: {
                        required: false,
                    },
                    saman_bank_account: {
                        required: false,
                    },
                    sanbod_pasargad_bank_account: {
                        required: false,
                    },
                    faraboom_melli_bank_account: {
                        required: false,
                    },
                    mellat_bank_account: {
                        required: false,
                    },
                    sanbod_parsian_bank_account: {
                        required: false,
                    },
                    // sanbod_tejarat_bank_account: {
                    //     required: true,
                    // },
                    ayande_bank_account: {
                        required: false,
                    },

                    wage_type: {
                        required: false,
                    },
                    wage_percent: {
                        required: () => {
                            return this.form_data.wage_type === walletWageType.PERCENT
                                || this.form_data.wage_type === walletWageType.LIMITED_PERCENT;
                        },
                    },
                    wage_amount: {
                        required: () => {
                            return this.form_data.wage_type === walletWageType.CONSTANT
                                || this.form_data.wage_type === walletWageType.LIMITED_PERCENT;
                        },
                    },
                    min_wage_amount: {
                        required: () => {
                            return this.form_data.wage_type === walletWageType.LIMITED_PERCENT;
                        },
                    },

                    paystar_wage_type: {
                        required: false,
                    },
                    paystar_wage_percent: {
                        required: () => {
                            return this.form_data.paystar_wage_type === walletWageType.PERCENT
                                || this.form_data.paystar_wage_type === walletWageType.LIMITED_PERCENT;
                        },
                    },
                    paystar_wage_amount: {
                        required: () => {
                            return this.form_data.paystar_wage_type === walletWageType.CONSTANT
                                || this.form_data.paystar_wage_type === walletWageType.LIMITED_PERCENT;
                        },
                    },
                    paystar_min_wage_amount: {
                        required: () => {
                            return this.form_data.paystar_wage_type === walletWageType.LIMITED_PERCENT;
                        },
                    },
                    paystar_wage_charge_type: {
                        required: false,
                    },
                    paystar_wage_charge_percent: {
                        required: () => {
                            return this.form_data.paystar_wage_charge_type === walletWageType.PERCENT
                                || this.form_data.paystar_wage_charge_type === walletWageType.LIMITED_PERCENT;
                        },
                    },
                    paystar_wage_charge_amount: {
                        required: () => {
                            return this.form_data.paystar_wage_charge_type === walletWageType.CONSTANT
                                || this.form_data.paystar_wage_charge_type === walletWageType.LIMITED_PERCENT;
                        },
                    },
                    paystar_min_wage_charge_amount: {
                        required: () => {
                            return this.form_data.paystar_wage_charge_type === walletWageType.LIMITED_PERCENT;
                        },
                    },

                    releasing_type: {
                        required: false,
                    },
                    account_balance: {
                        required: () => {
                            return this.form_data.releasing_type === releasingType.BASED_ON_BALANCE;
                        },
                    },
                    settlement_provider_variant: {
                        required: false,
                    },
                    company_wage_account: {
                        required: false,
                    },
                    company_wage_account_origin_bank: {
                        required: false,
                    },
                    skip_days: {
                        required: false,
                    },
                    settlement_request_period_limit: {
                        required: false,
                    },
                    is_active: {
                        required: false,
                    },
                    upcoming_settlement_wage_percent: {
                        required: false,
                    },
                    upcoming_settlement_wage_max: {
                        required: false,
                    },
                    upcoming_settlement_wage_min: {
                        required: false,
                    },
                }
            });

            if (!form.valid()) {
                return;
            }

            this.form_meta_data.submit_btn_progress = true;

            let params = {
                wallet_prefix: 'A',

                selected_gateway: this.form_data.selected_gateway,

                wage_type: this.form_data.wage_type,
                wage_percent: this.form_data.wage_percent,
                wage_amount: this.form_data.wage_amount,
                min_wage_amount: this.form_data.min_wage_amount,

                paystar_wage_type: this.form_data.paystar_wage_type,
                paystar_wage_percent: this.form_data.paystar_wage_percent,
                paystar_wage_amount: this.form_data.paystar_wage_amount,
                paystar_min_wage_amount: this.form_data.paystar_min_wage_amount,

                refund_wage_type: this.form_data.refund_wage_type,
                refund_wage_percent: this.form_data.refund_wage_percent,
                refund_wage_amount: this.form_data.refund_wage_amount,
                refund_min_wage_amount: this.form_data.refund_min_wage_amount,

                paystar_wage_charge_type: this.form_data.paystar_wage_charge_type,
                paystar_wage_charge_percent: this.form_data.paystar_wage_charge_percent,
                paystar_wage_charge_amount: this.form_data.paystar_wage_charge_amount,
                paystar_min_wage_charge_amount: this.form_data.paystar_min_wage_charge_amount,

                releasing_type: this.form_data.releasing_type,
                account_balance: this.form_data.account_balance,

                iban_detect_status: this.form_data.iban_detect_status,
                is_transfer_valid: this.form_data.is_transfer_valid,
                iban_detect_wage: this.form_data.iban_detect_wage,

                saderat_bank_account: this.form_data.saderat_bank_account,
                keshavarzi_bank_account: this.form_data.keshavarzi_bank_account,
                saman_bank_account: this.form_data.saman_bank_account,
                sanbod_pasargad_bank_account: this.form_data.sanbod_pasargad_bank_account,
                faraboom_melli_bank_account: this.form_data.faraboom_melli_bank_account,
                mellat_bank_account: this.form_data.mellat_bank_account,
                sanbod_parsian_bank_account: this.form_data.sanbod_parsian_bank_account,
                sanbod_sina_bank_account: this.form_data.sanbod_sina_bank_account,
                sanbod_tejarat_bank_account: this.form_data.sanbod_tejarat_bank_account,
                ayande_bank_account: this.form_data.ayande_bank_account,
                saderat_settlement_bank_account: this.form_data.saderat_settlement_bank_account,
                // saman_settlement_bank_account: this.form_data.saman_settlement_bank_account,
                // ayande_settlement_bank_account: this.form_data.ayande_settlement_bank_account,
                // keshavarzi_settlement_bank_account: this.form_data.keshavarzi_settlement_bank_account,

                settlement_provider_variant: this.settlement_provider_variant,
                company_wage_account: this.form_data.company_wage_account,
                company_wage_account_origin_bank: this.form_data.company_wage_account_origin_bank,

                skip_days: this.form_data.skip_days,
                settlement_request_period_limit: this.form_data.settlement_request_period_limit,
                is_active: this.form_data.is_active,
                settlement_limit: this.form_data.settlement_limit,

                upcoming_settlement_wage_percent: this.form_data.upcoming_settlement_wage_percent,
                upcoming_settlement_wage_max: this.form_data.upcoming_settlement_wage_max,
                upcoming_settlement_wage_min: this.form_data.upcoming_settlement_wage_min,

                last_priority_for_iban_info: this.form_data.last_priority_for_iban_info,
                first_priority_for_iban_info: this.form_data.first_priority_for_iban_info,
            };

            const setGlobalSetting = this.fetch_starshop
                ? walletService.setStarShopGlobalSettings
                : walletService.setGlobalSettings;

            setGlobalSetting(params).then(response => {
                this.showMsg(form, 'success', response.data.message);
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data);
                }

                this.showMsg(form, 'danger', response.data.message);
            }).finally(() => {
                this.form_meta_data.submit_btn_progress = false;
                window.scrollTo({top: 1, behavior: 'smooth'});
            });
        },
        initSelectPicker() {
            setTimeout(() => {
                $('.kt-selectpicker').selectpicker({
                    size: 4,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected')
                })
            }, 1000);
        },
    },
    mounted() {
        let globalSetting = walletService.getGlobalSettings;

        if (this.fetch_starshop) {
             globalSetting = walletService.getStarShopGlobalSettings;
        }

            let params = {
                wallet_prefix: 'A',
            };

        globalSetting(params).then(response => {
            this.wallet_data_fetched_successfully = true;
            this.form_data = response.data.data;
            this.initSelectPicker();
        });
    },
}
</script>
